import './emailTpvReport.css';
import ai from "../../../_metronic/images/Ai.svg"

const EmailTpvReport = ({ emailValidationResult }: any) => {
    const result = emailValidationResult;
    const confidence = Math.round(result?.score);

    const isDisposable = result?.is_suspected_disposable_address;
    const isBounce = result?.has_suspected_bounces;

    let status: 'valid' | 'review' | 'invalid' = 'valid';
    if (result?.verdict === 'Risky') status = 'review';
    if (result?.verdict === 'Invalid') status = 'invalid';

    const getStatusColor = (label: string) => {
        switch (label) {
            case "Valid":
                return "success";
            case "Invalid":
                return "danger";
            default:
                return "warning";
        }
    };

    const statusConfig = {
        valid: {
            label: 'Valid',
        },
        review: {
            label: 'Need Review',
        },
        invalid: {
            label: 'Invalid',
        },
    }[status];
    const color = getStatusColor(statusConfig?.label);

    const getInsightMessage = () => {
        if (status === "valid") {
            return "Email looks safe and deliverable";
        }
        if (status === "review") {
            return "Email may be a risky manual review recommended";
        }
        return "Invalid email likely undeliverable";
    };

    return (
        <div className="card card-clean shadow-sm h-100">
            <div className="card-header-clean d-flex align-items-center gap-2">
                <i className="bi bi-envelope text-primary"></i>
                Email Intelligence
            </div>
            <div className="card-body-clean">
                <div className="status-row">
                    <div className="fw-semibold fs-5">{result?.email}</div>
                    <span className={`soft-badge ${color === "success"
                        ? "soft-success"
                        : color === "danger"
                            ? "soft-danger"
                            : "soft-warning"
                        }`}>
                        {statusConfig.label}
                    </span>
                </div>
                <div className="progress-wrapper">
                    <div className="fw-bold">{confidence}%</div>
                    <div className="flex-grow-1">
                        <div className="progress">
                            <div
                                className={`progress-bar bg-${color}`}
                                style={{ width: `${confidence}%` }}
                            />
                        </div>
                    </div>
                </div>
                <div className="info-row p-1">
                    <div className="info-label">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle text-danger" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                        Suspected Disposable
                    </div>
                    <div>{isDisposable ? "Yes" : "No"}</div>
                </div>

                <div className="info-row p-1">
                    <div className="info-label">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-octagon" viewBox="0 0 16 16">
                            <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z" />
                            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                        </svg>
                        Suspected Bounce
                    </div>
                    <div>{isBounce ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="insight-box fw-bold gap-0">
                <img
                    src={ai}
                    alt="ai-icon"
                    className="ai-icon-email-report"
                />
                {getInsightMessage()}
            </div>
        </div>
    );
};

export default EmailTpvReport;